import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/login.vue'
import index from './components/index.vue'
import Verify from './views/verify.vue'
import Forgot from './views/forgot.vue'
import Dashboard from "./pages/dashboard";
import Customers from "./pages/customer-v2.vue"
import Admin from "./pages/admin"
import AdminIndex from "./pages/admin-index"
import Users from "./pages/admin-users";
import Games from "./pages/admin-games";
import AddGames from "./pages/admin-add-games";
import CreateUser from "./pages/admin-users-add";
import PickBox from "./pages/admin-pickbox-games.vue";
import Transaction from "./pages/transaction";
import Profiles from "./pages/profiles";
import Deposit from "./pages/deposit.vue";
import SpinWheel from "./pages/spinwheel_bets.vue";
import AviatorBets from "./pages/aviator_bets.vue";
import PickboxBets from "./pages/pickbox_bets.vue";
import withdraws from './pages/withdraws.vue'
import USSDPayments from './pages/admin-pending-ussd-payments.vue'
import adminAccessLogs from './pages/admin-accessLogs.vue'
import adminAdminLogs from './pages/admin-adminLogs.vue'
import adminBlast from './pages/admin-blast.vue'
import adminBonus from './pages/admin-bonus.vue'
import ticketsIndex from './pages/tickets/tickets-index.vue'
import TicketsIndex from './pages/tickets/tickets-index.vue'
import ticketsPriority from './pages/tickets/tickets-priority.vue'
import ticketsView from './pages/tickets/tickets-view.vue'
import ticketsType from './pages/tickets/tickets-type.vue'
import ticketsStatus from './pages/tickets/tickets-status.vue'
import ticketsSubType from './pages/tickets/tickets-sub-type.vue'
import ticketsAction from './pages/tickets/tickets-action.vue'
//SportBook
import sportbookIndex from './pages/sportbook/sportbook-index.vue'
import sportbookMatche from './pages/sportbook/sportbook-matche.vue'
import sportbookMatcheArchived from './pages/sportbook/sportbook-matche-archived.vue'
import sportbookBets from './pages/sportbook/sportbook-bets.vue'
import sportbookSports from './pages/sportbook/sportbook-sports.vue'
import sportbookCompetition from './pages/sportbook/sportbook-competition.vue'
import SportbookPendingMatche from './pages/sportbook/sportbook-pending-matche.vue'
import sportbookCategory from './pages/sportbook/sportbook-category.vue'
import sportbookCountry from './pages/sportbook/sportbook-country.vue'
import sportbookMarket from './pages/sportbook/sportbook-market.vue'
//KRA
import kraIndex from './pages/kra/kra-index.vue'
import kraTax from './pages/kra/kra-tax.vue'
import kraStakeTax from './pages/kra/kra-stake-tax.vue'
import kraOutcomeTax from './pages/kra/kra-outcome-tax.vue'


Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        //{ path: '', name: 'home', component: Home },
        { path: '/', name: 'login', component: Login },
        { path: '/verify', name: 'verify', component: Verify },
        { path: '/forgot', name: 'forgot', component: Forgot },
        { path: '/app', component: index, children: [
            { path: '', name: 'dashboard', component: Dashboard, meta: { name: 'Dashboard' } },
            { path: 'transaction', name: 'transaction', component: Transaction, meta: { name: 'Transaction' } },
            { path: 'withdraws', name: 'withdraws', component: withdraws, meta: { name: 'Withdraws' } },
            { path: 'spinwheel/bets', name: 'spinWheel', component: SpinWheel, meta: { name: 'SpinWheel Bets' } },
            { path: 'aviator/bets', name: 'aviatorBets', component: AviatorBets, meta: { name: 'Aviator Bets' } },
            { path: 'pickbox/bets', name: 'pickboxBets', component: PickboxBets, meta: { name: 'Pickbox Bets' } },
            { path: 'profiles', name: 'profiles', component: Profiles, meta: { name: 'All Profiles' } },
            { path: 'deposit', name: 'deposit', component: Deposit, meta: { name: 'All Deposit' } },
            { path: 'customers', name: 'customers', component: Customers, meta: { name: 'Customers' } },
            { path: 'admin', component: AdminIndex, children: [
                { path: '', name: 'admin', component: Users, meta: { name: 'Admin' } },
                { path: 'users', name: 'users', component: Users, meta: { name: 'Admin > Users' } },
                { path: 'access/logs', name: 'adminAccessLogs', component: adminAccessLogs, meta: { name: 'Admin > Access Logs' } },
                { path: 'logs', name: 'adminAdminLogs', component: adminAdminLogs, meta: { name: 'Admin > Logs' } },
                { path: 'pickbox', name: 'pickBox', component: PickBox, meta: { name: 'Admin > PickBox' } },
                { path: 'games', name: 'games', component: Games, meta: { name: 'Admin > Games' } },
                { path: 'ussd/pending/payments', name: 'USSDPayments', component: USSDPayments, meta: { name: 'Admin > Pending USSD Payment' } },
                { path: 'games/add', name: 'addgames', component: AddGames, meta: { name: 'Admin > Add Games' } },
                { path: 'users/add', name: 'addUser', component: CreateUser, meta: { name: 'Admin > Create User' } },
                { path: 'blast', name: 'blast', component: adminBlast, meta: { name: 'Admin > Blast' } },
                { path: 'bonus', name: 'bonus', component: adminBonus, meta: { name: 'Admin > Bonus' } },
                
            ] },
            { path: 'ticket', component: TicketsIndex, children: [
                { path: '', name: 'ticket', component: ticketsView, meta: { name: 'View Ticket' } },
                { path: 'view/:id', name: 'ticketAction', component: ticketsAction, meta: { name: 'View Comments' } },
                { path: 'view/priority', name: 'ticketPriority', component: ticketsPriority, meta: { name: 'Ticket Priority' } },
                { path: 'view/type', name: 'ticketType', component: ticketsType, meta: { name: 'Ticket Type' } },
                { path: 'view/sub/type', name: 'ticketSubType', component: ticketsSubType, meta: { name: 'Ticket SubType' } },
                { path: 'view/status', name: 'ticketStatus', component: ticketsStatus, meta: { name: 'Ticket Status' } },
            ] },

             { path: 'sportbook', component: sportbookIndex, children: [
                { path: 'matche', name: 'matche', component: sportbookMatche, meta: { name: 'View Matche' } },
                { path: 'matche/archived', name: 'matcheArchived', component: sportbookMatcheArchived, meta: { name: 'View Matche Archived' } },
                { path: 'bets', name: 'sportbet', component: sportbookBets, meta: { name: 'View Bets' } },
                { path: 'sport', name: 'sports', component: sportbookSports, meta: { name: 'View Sports' } },
                { path: 'competition', name: 'competition', component: sportbookCompetition, meta: { name: 'View Competition' } },
                { path: 'matche/pending', name: 'matchePending', component: SportbookPendingMatche, meta: { name: 'View Pending Matche' } },
                { path: 'category', name: 'category', component: sportbookCategory, meta: { name: 'View Categories' } },
                { path: 'country', name: 'country', component: sportbookCountry, meta: { name: 'View Countries' } },
                { path: 'market', name: 'market', component: sportbookMarket, meta: { name: 'View Markets' } },
            ] },
            { path: 'kra', component: kraIndex, children: [
                { path: 'tax', name: 'kraTax', component: kraTax, meta: { name: 'View KRA Tax' } },
                { path: 'stake/tax', name: 'kraStakeTax', component: kraStakeTax, meta: { name: 'View KRA Stake Tax' } },
                 { path: 'outcome/tax', name: 'kraOutcomeTax', component: kraOutcomeTax, meta: { name: 'View KRA Outcome Tax' } },

            ]}

        ] },
    ]
})
